<template>
  <div :class="componentClassName">
    <a-page-heading>通話録音テキスト化設定</a-page-heading>
    <m-section variant="fullpage">
      <m-action-card title="通話録音テキスト化の利用設定" :header-border="true" :narrow-body="true">
        <form ref="form" class="t-voice-to-text-setting-edit__form" @submit.prevent="handleFormSubmit">
          <div class="t-voice-to-text-setting-edit__fields">
            <m-form-input content-layout="vertical">
              <!-- <a-text>{{ voiceToTextToggleLabel }}</a-text>
              <a-switch id="voiceToTextToggle" v-model="voiceToTextOn" label="" :disabled="buttonDisable" /> -->
              <br />
              <a-radio
                v-show="voiceToTextOn"
                :id="voiceToTextSettingList[0].id"
                :key="voiceToTextSettingList[0].value"
                v-model="textSettingRadio"
                variant="button"
                name="voiceToTextSetting"
                :value="voiceToTextSettingList[0].value"
                :label="voiceToTextSettingList[0].label"
                :disabled="buttonDisable"
              />
              <a-radio
                v-show="voiceToTextOn"
                :id="voiceToTextSettingList[1].id"
                :key="voiceToTextSettingList[1].value"
                v-model="textSettingRadio"
                variant="button"
                name="voiceToTextSetting"
                :value="voiceToTextSettingList[1].value"
                :label="voiceToTextSettingList[1].label"
                :disabled="buttonDisable"
              />
              <template #note>
                <li>通話録音テキスト化の料金は、通話ごとに発生する従量課金制です。</li>
              </template>
            </m-form-input>
            <m-form-action-buttons>
              <a-button id="save" variant="block" color="primary" :disabled="buttonDisable" @click="handleSaveClick">
                保存
              </a-button>
              <a-button id="cancel" variant="outlined" color="primary" @click="handleCancelClick">
                キャンセル
              </a-button>
            </m-form-action-buttons>
          </div>
        </form>
      </m-action-card>
    </m-section>
  </div>

  <!-- Confirm, Error Modal -->
  <teleport to="body">
    <o-modal
      id="voiceTextEdit_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="close-modal-button"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal(next)"
        />
      </template>
    </o-modal>
  </teleport>

  <teleport to="body">
    <o-modal
      id="voiceTextEdit_comfirmModal"
      v-model:visible="settingConfirmModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="540px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
    >
      <template #title>{{ settingConfirmModalTitle }}</template>
      <a-text color="orange">設定変更内容：</a-text>
      <a-text color="orange">{{ displaySetting }}</a-text>
      <br />
      <a-text>
        <!-- eslint-disable -->
        <span v-html="settingConfirmModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="close-modal-button"
          variant="outlined"
          color="primary"
          label="キャンセル"
          size="small"
          @click="handleSettingConfirmCloseModal"
        />
        <a-button
          id="save-complete-button"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleSettingConfirmClickOk"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import MSection from '@/components/molecules/section';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import MFormInput from '@/components/molecules/form-input';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import OModal from '@/components/organisms/modal';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { POINT, voiceToTextSettings } from '@/libs/constants';

import { utils } from '@/common/utils.js';

export default {
  name: 't-voice-to-text-setting-edit',
  components: {
    APageHeading,
    MActionCard,
    MSection,
    MFormActionButtons,
    MFormInput,
    AButton,
    AText,
    OModal,
  },
  mixins: [messageContent, customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
    voiceToTextOnProps: {
      type: String,
      default: '',
    },
    voiceToTextFlgProps: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      textSettingRadio: 'false',
      voiceToTextOn: false,
      voiceToTextSettingList: [
        {
          id: 'selectedCallLog',
          value: 'false',
          label: 'テキスト化する通話を個別に選択する',
        },
        {
          id: 'allCallLog',
          value: 'true',
          label: 'すべての通話をテキスト化する',
        },
      ],
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      settingConfirmModalTitle: '',
      settingConfirmModalContent: '',
      settingConfirmModalVisible: false,
      authInfo: this.$store.state.user.authInfo,
      // For Trial
      saveButtonDisable: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-voice-to-text-setting-edit');
      return `${baseClassName} ${this.class}`.trim();
    },
    buttonDisable() {
      return this.authInfo !== 'supervisor';
    },
    voiceToTextToggleLabel() {
      return this.voiceToTextOn ? '通話録音テキスト化機能を利用する' : '通話録音テキスト化機能を利用しない';
    },
    displaySetting() {
      let setting = voiceToTextSettings[0].LABEL;
      if (this.voiceToTextOn) {
        setting = this.textSettingRadio === 'true' ? voiceToTextSettings[1].LABEL : voiceToTextSettings[2].LABEL;
      }
      return setting;
    },
  },
  created() {
    this.textSettingRadio = this.voiceToTextFlgProps ?? 'false';
    this.voiceToTextOn = this.voiceToTextOnProps === 'true';

    let invalidFlag = false;
    if (utils.chkTrialCompanyID(this.companyID)) {
      invalidFlag = true;
    }
    if (this.authInfo !== 'supervisor') {
      invalidFlag = true;
    }
    // 通録テキスト化機能（PoC対応）
    if (this.companyID !== POINT && !this.voiceToTextOn) {
      invalidFlag = true;
    }

    if (invalidFlag === true) {
      this.$router.push({ path: '/permission-denied' });
      return;
    }
  },
  methods: {
    handleCloseModal(next) {
      // #2512
      this.flagAllButtonsEnable = true;
      if (next) {
        this.$router.push(next);
      }

      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message, next = '') {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.next = next;
    },
    showSettingConfirmModal() {
      this.settingConfirmModalVisible = true;
      this.settingConfirmModalTitle = messageContent.confirmVoiceToTextSettingChangeTitle;
      this.settingConfirmModalContent = messageContent.confirmVoiceToTextSettingChange;
    },
    handleSettingConfirmCloseModal() {
      // #2512
      this.flagAllButtonsEnable = true;

      this.settingConfirmModalVisible = false;
      this.settingConfirmModalTitle = '';
      this.settingConfirmModalContent = '';
    },
    handleSettingConfirmClickOk(e) {
      this.handleSettingConfirmCloseModal();
      this.handleFormSubmit(e);
    },
    handleSaveClick(e) {
      if (this.voiceToTextOn) {
        this.showSettingConfirmModal();
      } else {
        this.handleFormSubmit(e);
      }
    },
    handleFormSubmit(e) {
      e.preventDefault();

      const sendData = {
        voiceToTextFlg: this.textSettingRadio === 'true',
        voiceToTextOn: this.voiceToTextOn,
      };

      return this.postRequest('/voicetotext/textSettingUpdate', { data: sendData })
        .then(e => {
          if (e.status === 'success') {
            this.showInfoModal(messageContent.voiceToTextSettingUpdated, '/voicetotext');
          } else {
            if (e.msg !== '') {
              this.showErrorModal(e.msg);
            } else {
              this.showErrorModal(messageContent.canNotUpdateVoiceToTextSetting);
            }
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.canNotUpdateVoiceToTextSetting);
        });
    },
    handleCancelClick() {
      if (this.companyID === POINT) {
        this.$router.push({ name: 'VoiceToText', query: { companyID: this.companyID } });
      } else {
        this.$router.push({ name: 'VoiceToText' });
      }
    },
  },
};
</script>
